<div *ngIf="listItems && listItems.length > 0">
  <h4>{{listTitle}}</h4>
  <app-unordered-list [listItems]="listItems"></app-unordered-list>
</div>